import type { Action } from 'redux'
import { combineReducers } from 'redux'

import { POST_BUG_REPORT, POST_BUG_REPORT_ERROR, POST_BUG_REPORT_SUCCESS } from './constants'

interface ReducerAction extends Action {
  payload: {
    errorCode?: number
  }
}

function errorCode(state: boolean | null = false, { payload, type }: ReducerAction) {
  switch (type) {
    case POST_BUG_REPORT:
    case POST_BUG_REPORT_SUCCESS:
      return null

    case POST_BUG_REPORT_ERROR:
      return payload?.errorCode

    default:
      return state
  }
}

function isLoading(state = false, { type }: Action) {
  switch (type) {
    case POST_BUG_REPORT:
      return true

    case POST_BUG_REPORT_ERROR:
    case POST_BUG_REPORT_SUCCESS:
      return false

    default:
      return state
  }
}

export default combineReducers({
  errorCode,
  isLoading,
})
